<script lang="ts">
  import Modal from "@ui/Modal.svelte";
  import { createEventDispatcher } from "svelte";
  import Checkbox from "@ui/Checkbox.svelte";

  const dispatch = createEventDispatcher();

  export let isOpen: boolean = false;
  let checked: boolean = false;
  let isSubmitting = false;
  let showError = false;

  async function submit(data: Record<string, any>) {
    if (!checked) {
      showError = true;
      setTimeout(() => (showError = false), 1600);
      return;
    }

    isSubmitting = true;
    dispatch("acceptedTerms");
    isSubmitting = false;
  }

  function cancel() {
    isOpen = false;
  }
</script>

<Modal bind:isOpen title="Almost there" hideIcon={true} boldTitle={true} --popup-width="430px">
  <span class="text-14 text-nxgray-500"> To complete your sign up please confirm the following by checking the box below: </span>

  <label for="terms" class="relative mt-4 flex w-full select-none justify-start text-sm">
    <div
      class="animate-error 0 absolute -bottom-2 -left-2 -right-2 -top-2 box-content rounded border-[1.5px] border-dashed transition-all"
      class:border-transparent={!showError}
      class:border-danger-600={showError} />
    <Checkbox name="terms" id="terms" autofocus={true} bind:checked required={true} />
    <div class="ml-2 text-14 text-nxgray-500">
      By signing up for a Smore account, you agree to our <a href="https://www.smore.com/terms/" class="text-teal-600">Terms of Service</a>
      and
      <a href="https://www.schoolstatus.com/master-services-agreement" class="text-teal-600">Master Service Agreement</a>
      unless your organization has agreed to other terms in writing.
    </div>
  </label>

  <div class="align-center mt-4 flex w-full items-center justify-between rounded-b px-2 py-2 pl-3">
    <button
      on:click|preventDefault|stopPropagation={cancel}
      class="clickable scale-in hover:text-danger-600 cursor-pointer text-13 text-nxgray-400 transition-colors">
      Cancel
    </button>

    <input
      type="submit"
      class="clickable bg-success-600 rounded px-3 py-1.5 text-14 font-medium text-white shadow transition-colors"
      on:click|preventDefault|stopPropagation={submit}
      class:hover:bg-success-500={checked}
      class:bg-nxgray-200={isSubmitting || !checked}
      class:text-gray-400={isSubmitting || !checked}
      class:cursor-not-allowed={isSubmitting || !checked}
      class:shadow-none={isSubmitting || !checked}
      value={isSubmitting ? "Continuing..." : "Continue"} />
  </div>
</Modal>

<style>
  .animate-error {
    animation: ping 0.4s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  @keyframes ping {
    50% {
      opacity: 0.2;
    }
  }
</style>
